import React, { useState, useEffect } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import {
  Form as FormUi,
  Container, TextArea, Dropdown
} from "semantic-ui-react";
import ReadAxios from "../../../components/axiosComponent/read";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import CreateAxios from "../../../components/axiosComponent/create";
import UpdateAxios from "../../../components/axiosComponent/update";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { AllRegex } from "../../../utils/validation";
import { ERROR_MESSAGES, INVALID_FIELDS, REQUIRED_FIELDS } from "../../../utils/validationConstant";
import {FEATURES, LOCAL_STORAGE} from '../../../utils/constant'
import {LABELS, PLACE_HOLDERS, BUTTONS, MESSAGES} from './skuTypeConstants'
import cogoToast from "cogo-toast";
import MyCategory from "../../../components/apiInputs/myCategory";
import LoadType from "../../../components/dynamicComponent/loadType";

const currentUser = LOCAL_STORAGE.customerNo

const InsertSkuType = ({ values, setFieldValue, touched, errors, t }) => {

  return (
    <React.Fragment>
      <Formiker>
        <div className="container-fluid animated slideInDown pad w3-white">
          <div className="ml-3 mr-3 mt-5 mb-5 pl-3">
            <div className="ui form">
              <FormUi.Group inline>
              <FormUi.Field width={3}>
                  <label className="labelName">
                    {LABELS.sku_type_code||"Product Category Code"}
                  </label>
                </FormUi.Field>
              <FormUi.Field width={4}>

                <Fieldmik
                type="text"
                className="ui input pe-5"
                name="serviceCategoryCode"
                placeholder={PLACE_HOLDERS.sku_type_code||"Category Code"}
                disabled={values.isEditing}
                error={true ? true : false}

              />
              </FormUi.Field>
              <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={3}>
                  <label className="labelName">
                    {LABELS.sku_type_name||"Product Category"}<span className="red"> *</span>
                  </label>
                </FormUi.Field>
                <FormUi.Field className="display-grid-center-imp" width={4} error={touched.serviceCategory && errors.serviceCategory ? true : false}>
                  <div className="container">
                    <div className="row">
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="serviceCategory"
                        placeholder={PLACE_HOLDERS.sku_type_name||"Category Name"}
                        />
                    </div>
                    {/* <div className="row"> */}
                      {touched.serviceCategory && errors.serviceCategory ? (
                        <div className="error-msg" style={{position: 'absolute'}}>
                          {errors.serviceCategory}
                        </div>
                      ) : null}
                    {/* </div> */}
                  </div>
                </FormUi.Field>
              </FormUi.Group>

              
              <FormUi.Group inline>
                {FEATURES.isolationAndLoadTypeEnabledInProductCategory &&
                  <>
                    <FormUi.Field width={3}>
                      <label className="labelName">
                        {LABELS.load_type || "Load Type"}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field width={4}>
                      <Fieldmik
                        component={LoadType}
                        className="ui input"
                        name="loadTypeId"
                        placeholder={PLACE_HOLDERS.load_type || "Load Type"}
                        value={values.loadTypeId}
                      />
                    </FormUi.Field>
                  </>
                }
              <FormUi.Field width={2}></FormUi.Field>
              <FormUi.Field width={3}>
                  <label className="labelName">
                    {LABELS.is_gst_exempted||"Is GST Exempted"}
                  </label>
                </FormUi.Field>
              <FormUi.Field >

                <Fieldmik
                type="checkbox"
                className="ui input"
                name="isGstExempted"
                // placeholder={
                //   t("add_new_sku.sku_type_name.placeholder") || "Name"
                // }
              />
                </FormUi.Field>

              </FormUi.Group>
              <FormUi.Group inline>   
                {FEATURES.isolationAndLoadTypeEnabledInProductCategory &&
                  <>
                    <FormUi.Field width={3}>
                      <label className="labelName">
                        {LABELS.product_isolation || "Isolation Category"}
                      </label>
                    </FormUi.Field>
                    <FormUi.Field width={4}>

                      <Fieldmik
                        component={MyCategory}
                        className="ui input"
                        name="isolationCategoryIds"
                        placeholder={PLACE_HOLDERS.product_isolation || "Isolation Category"}
                        value={values.isolationCategoryIds}
                        multiple
                        idValue={true}
                        restrictCategoryId={values.serviceCategoryId}
                      />
                    </FormUi.Field>
                  </>
                }

              </FormUi.Group>
            </div>
          </div>
        </div>
        <Container className="p-3" textAlign="center">
          <button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="submit"
          >
            {BUTTONS.submit||"Submit"}
          </button>
        </Container>
      </Formiker>
    </React.Fragment>
  );
};

const FormikSkuType = withFormik({
  validationSchema: yup.object({
    serviceCategory: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).max(30, ERROR_MESSAGES.MAX_LENGTH(30))
  }),
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    return {
        serviceCategory: props.editData?.serviceCategory || "",
        serviceCategoryCode: props.editData?.serviceCategoryCode || "",
        isGstExempted: props.editData?.isGstExempted == 'Yes' ? true : false,
        isEditing: props.editData?.serviceCategoryId ? true : false,
        loadTypeId: props.editData?.loadTypeId || "",
        isolationCategoryIds: props.editData?.isolationCategoryIds || [],
        serviceCategoryId : props.editData?.serviceCategoryId || ""
    };
  },
  async handleSubmit(values, { props, resetForm }) {
    if (props.editData.serviceCategoryId) {
      delete values.isEditing;
      UpdateAxios({
        url: "service_category",
        payload: { ...values },
        uniqueId: props.editData.serviceCategoryId,
      })
        .then((res) => {
          // let alert = {
          //   type: "success",
          //   messageHeader: "Success",
          //   messageBody: res.data.message,
          // };
          // props.successAlertDispatcher(alert);
          cogoToast.success(res.data?.message || MESSAGES.updateSuccess, { position: 'top-right' });
          resetForm()
          props.onFormSubmit();
        })
        .catch((err) => {
        //   let alert = {
        //     type: "error",
        //     messageHeader: "Error",
        //     messageBody: err.data.message,
        //   };
        cogoToast.error(err.data?.message || MESSAGES.updateFailure, { position: 'top-right' });
        resetForm()
          console.log(err,'eeee');
          //props.errorAlertDispatcher(alert);
        });
    } else {
      CreateAxios({
        url: "service_category",
        payload: { ...values },
      })
        .then((res) => {
          console.log({result: res})
          if(res?.data?.status == 204){
            cogoToast.error(res?.data?.message, { position: 'top-right' });
            resetForm()
            props.onFormSubmit();
            return
          }
          cogoToast.success(res?.data?.message, { position: 'top-right' });
          props.onFormSubmit();
        })
        .catch((err) => {
          console.log("error sku", err);
          resetForm()
          cogoToast.error(err.data.message, { position: 'top-right' });
        });
    }
  },
})(InsertSkuType);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("skuType")(FormikSkuType)
);
